import React, { useEffect, useState } from "react";
import { Dimmer } from "../spinner";
import axios from "axios";

export const TimbreActu = () => {
  let op = require("../../modulos/datos");
  const [status, setStatus] = useState(false);
  const [socket, setSocket] = useState();
  const [baseDatos, setBaseDatos] = useState([]);
  const [activate, setActivate] = useState(false);
  const token = localStorage.getItem("jwtToken");

  const [local, setLocal] = useState(0)
  const [pendientesLocal, setPendientesLocal] = useState(0)
  const [sincronizadosLocal, setSincronizadosLocal] = useState(0)


  const [web, setWeb] = useState(0)
  const [pendientesWeb, setPendientesWeb] = useState(0)
  const [sincronizadosWeb, setSincronizadosWeb] = useState(0)




  const sincronizar = () => {


    //let sock = new WebSocket('wss://sistema.opensiap.com.ve/api/socket');
    let sock = new WebSocket(`${op.conexionsiapactu}`);

    sock.onmessage = (event) => {
      document.getElementById("line").innerHTML += `<p>${event.data}</p>`;
    };

    sock.onopen = () => {
      console.log("Connected to the server");
      document.getElementById("line").innerHTML = "";
      sock.send("cd /opt/SiapActu");

      //sock.send("pwd");

      sock.send("./SiapActu");
    };

    sock.onclose = () => {
      console.log("Disconnected from the server");
    };

    setSocket(sock);

    setStatus(true);
  };

  const cancelar = () => {
    socket.close();
    document.getElementById("line").innerHTML = "";
    setStatus(false);
  };

  const seleccionarLocal = (datos) => {
    console.log('seleccionarLocal')

    let body = {
      ip: datos.ip,
      nombre: datos.nombre,
      contrasena: datos.contraseña,
      puerto: datos.puerto,

    }

    let endpoint = `${op.conexion}/api/industria/movlocal`

    setActivate(true);

    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          //setBaseDatos(response.data);
          setLocal(response.data.length)
          setPendientesLocal(response.data.length)
          console.log(response.data)
        }
      })
      .catch(function (error) {
        /* setMensaje({
            mostrar: true,
            titulo: "Error",
            texto: error.response.data.message,
            icono: "error",
        }); */
      })
      .finally(() => setActivate(false));
  };

  const seleccionarWeb = (datos) => {
    console.log('seleccionarWeb')

    let body = {
      ip: datos.ip,
      nombre: datos.nombre,
      contrasena: datos.contraseña,
      puerto: datos.puerto,

    }

    let endpoint = `${op.conexion}/api/industria/movweb`

    setActivate(true);

    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          //setBaseDatos(response.data);
          setWeb(response.data.length)
          setPendientesWeb(response.data.length)
          console.log(response.data)
        }
      })
      .catch(function (error) {
        /* setMensaje({
            mostrar: true,
            titulo: "Error",
            texto: error.response.data.message,
            icono: "error",
        }); */
      })
      .finally(() => setActivate(false));
  };

  const seleccionarBasedeDatos = () => {

    let campos = "*";
    let nomtab = "basedatos";
    let orden = 'idbasedatos';
    let endpoint = `${op.conexion}/api/comun/seleccionaregistros?campos=${campos}&nomtab=${nomtab}&orden=${orden}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setBaseDatos(response.data);

          for (let i = 0; i < response.data.length; i++) {
            if (response.data[i].tipo === 'local') {
              seleccionarLocal(response.data[i])
            } else {
              seleccionarWeb(response.data[i])
            }
          }

        }
      })
      .catch(function (error) {
        /* setMensaje({
            mostrar: true,
            titulo: "Error",
            texto: error.response.data.message,
            icono: "error",
        }); */
      })
      .finally(() => setActivate(false));
  };

  useEffect(() => {
    seleccionarBasedeDatos();
  }, []);


  return (
    <div className="card">
      <Dimmer active={activate} inverted>

      </Dimmer>
      <div
        style={{
          padding: 20,
          margin: "auto",
          height: "80vh",
          width: "90%",
          overFlow: "auto",
        }}
      >
        <div className="col-md-12 row mx-auto px-0">
          <div className="col-md-6 row mx-auto px-1">

            <div className="col-md-12 mx-auto row py-3 bg-local rounded-card">
              <h3 class="text-right text-light mb-0 fw-bold">Base de Datos Local</h3>
              <label class="col-md-12 fw-bold text-light mb-0">Movimientos: {local}</label>

              <label class="col-md-6 text-light fw-bold">Pendientes:   {pendientesLocal} </label>
              <label class="col-md-6 text-light fw-bold">Sincronizados:   {sincronizadosLocal} </label>

            </div>
          </div>
          <div className="col-md-6 row mx-auto px-1">

            <div className="col-md-12 mx-auto row py-3 bg-web rounded-card">
              <h3 class="text-right text-light mb-0 fw-bold">Base de Datos Web</h3>
              <label class="col-md-12 fw-bold text-light mb-0">Movimientos: {web}</label>

              <label class="col-md-6 text-light fw-bold">Pendientes:   {pendientesWeb} </label>
              <label class="col-md-6 text-light fw-bold">Sincronizados:   {sincronizadosWeb} </label>
            </div>
          </div>


        </div>

        <div
          id="app"
          style={{
            width: "100%",
            height: "40vh",

          }}
        >

          <div id="terminal" className="rounded-card mt-2 mb-0">
            <div className="history">
              <div id="line" className="line"></div>
            </div>
          </div>
        </div>
        <div className='col-md-12 mx-auto row d-flex justify-content-end mt-2 px-0'>
          <button
            className="btn btn-success col-md-3 mx-1"
            disabled={status}
            onClick={sincronizar}
          >
            <i className="fas fa-sync"> Sincronizar</i>
          </button>
          <button
            className="btn btn-danger col-md-3 mx-1"
            disabled={!status}
            onClick={cancelar}
          >
            <i className="fas fa-window-close"> Cancelar</i>
          </button>
        </div>

      </div>
    </div>
  );
};
